var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#032ea1",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e00025",
    d: "M.7 10H54v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M21.7 18.9h11.4v4.3H21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M32.5 21.3h.4v1.6h-.4zm-10.8-.8h11.4v.5H21.7zm0-.7h11.4v.4H21.7zm0-.8h11.4v.5H21.7zm3 2.3h.4v1.6h-.4zm4.9 0h.4v1.6h-.4zm-7.8 0h.4v1.6h-.4zm.7 0h.4v1.6h-.4zm.8 0h.3v1.6h-.3zm.7 0h.4v1.6H24zm6.3 0h.3v1.6h-.3zm.7 0h.4v1.6H31zm.8 0h.3v1.6h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17.3 23.5.4-.6H37q0 .3.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.1 12.2s0-.4.2-.4.3.4.3.4zm-1.2 5.4v-.5l-.3-.5V16q.2.5.3.2t-.3-.6V15q0 .4.3.4l.1-.2-.2-.5.1-.5q0 .4.2.4c.3 0 0-.4 0-.5v-.4l.2.3q.2 0 0-.4v-.3q.2.3.2 0V13h1.7v.5h.2v.2q-.3.3 0 .4l.1-.3.1.4s-.3.5 0 .5l.1-.4.1.5-.2.5q0 .2.2.2t.2-.4q.2.3 0 .6l-.3.6q0 .3.3-.2v.5l-.2.5v.5zm.7-4.6v-.3H28v.3zm0-.3v-.2H28v.2zm.3-.2v-.3h.9v.3zm3.3 11q-.4-.2-.5-.6v-2.4l.3-.3h-5.3l.3.3V23q0 .4-.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M25.6 21.3h.4v1.6h-.4zm3 0h.4v1.6h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.6 17.4v2.8H30v-2.8l-.3.3v1.2H25v-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.3 23.5q-.4-.2-.6-.6v-2.7l.4-.3h-3.6q.4 0 .4.3V23q-.1.3-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.7 20v-2h-.4v-.2h-4v.2H25v2zm-1.2 3.4q-.4 0-.4-.4v-2.4l.1-.2h-1.8l.2.2V23q-.1.4-.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.9 20.4h.9v3h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M28.2 19.8c0-.2.6-.3 1-.4h-3.7c.3.1.9.2.9.4l.1.3 1.5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m29 17.6.1-.6v1.5c-.4.1-.6.6-.6.6h-2.3s-.3-.5-.7-.6v-1.6q.3 0 .2.7zm.1-.2c0-.5.5-.6.5-.6v.5q-.3 0-.3.4.1.4.2.3v1.4H29zm-3.6 0c0-.5-.5-.6-.5-.6v.5q.3 0 .3.4l-.1.3v1.4h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.5 13.6h1.7m-2 .5h2.2m-2.3.7h2.5m-2.7.7h3m-3.1 1h3m-3.9 2.9h4.8m-3.3 0h1.8v.7h-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.2 18q.4.6.3 1.3h1.7q0-.7.3-1.4zm1-4.2-.3-.1v-.4l.3.2.1-.3q.2 0 .2.3l.2-.2v.4l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.2 14.4-.4-.3v-.3q.2 0 .3.2l.2-.4q.3 0 .3.4 0-.2.3-.2v.3l-.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.1 15.3-.4-.4v-.5q.2 0 .3.3 0-.4.3-.7l.4.7q0-.2.3-.3v.5l-.4.4zm.9.5-.4.6H27l-.4-.6zm-1.6 1q.3 0 .3.7H28q0-.6.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M28.2 15.8v-.6l-.4.4q0-.5-.5-.9l-.5.9q0-.3-.4-.4v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M28.3 16.8v-.6q-.3 0-.4.3 0-.4-.6-.8-.6.4-.5.8l-.5-.3v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M28.5 18v-.7l-.5.3q-.1-.6-.7-1-.6.4-.7 1l-.5-.3v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M28.4 19.4v-.7l-.4.5q-.1-1.2-.7-1.6-.6.5-.7 1.6 0-.3-.4-.5v.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.2 20.4v-.7l-.3.3q0-.6-.6-1-.5.4-.6 1l-.3-.3v.7zM17.7 23v-2.1q-.1-.4-.5-.6v-1.8l.4.2.4 2v2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.7 23v-2.1q-.1-.4-.5-.6v-1.9l.4.3.4 2v2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.4 23.5q.4-.2.5-.5v-2.6l-.2-.2h4.4l-.2.2V23l.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.4 23.5q-.4-.2-.4-.5v-2.5l.3-.3h-3l.4.3V23q0 .3-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21 23.5q-.4-.2-.5-.6v-2.1l.3-.4h-1.9l.2.4v2.1q0 .4-.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.4 20.4h.9v3h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.2 21.3h.3v1.6h-.3zm3 0h.4v1.6h-.4zM18 18.5h.4v1.7H18zm0-.3h.4v.3H18zm3.5.7h.6v1.3h-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M17.9 18.5h.4v1.7h-.4zm0 0h.4v-.3h-.4zm.3 2.8h.3v1.6h-.3zm3 0h.4v1.6h-.4zm.2-2.4h.6v1.3h-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.3 20.2v-3c.1 0 .1.5.4.5q.3 0 0-.3v-.7q.2.5.3.2-.2-.2-.1-.7.1.4.2.1v-.6q.1.5.2 0-.1-.4.4-.7l.2-.3.2.3q.5.2.4.8 0 .3.2-.1v.6q0 .3.2-.1.1.4-.2.7 0 .2.3-.2v1q.4-.2.4-.4v2.9zm-.7-2.2v2.2h.3V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.6 19.4q.5.3.7.8h-.7zm4.3-.7v1.5h.2v-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.1 19.4q-.5.2-.7.8h.7zm-2-3.4.2-.1v-.2H20l-.2-.2-.3.3-.1-.1v.2l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.2 16.5v-.4l-.3-.2-.3.3-.1-.1v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m20.2 17.2.3-.3v-.4l-.3.2q0-.3-.3-.4-.3.1-.4.4l-.2-.2v.4l.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.3 17.8q.2 0 .3-.4v-.3l-.3.2q-.1-.4-.4-.5t-.5.5q0-.2-.3-.2v.3q0 .3.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m20.4 19 .5-.6v-.6q-.3 0-.5.4 0-.7-.5-1-.5.3-.6 1l-.4-.4v.6q.2.5.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m20.4 19.7.5-.5v-.5q-.3 0-.5.3l-.5-.9q-.5.3-.6 1-.2-.4-.4-.4v.5l.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.6 20.2q0-.7-.8-1.2-.7.4-.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.8 20.4v-.7l-.5.4q-.1-.5-.5-.7l-.4.7-.5-.4v.7zM37 23v-2.1q.1-.4.4-.6v-1.8l-.3.2-.5 2v2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37 23v-2.1q.1-.4.4-.6v-1.9l-.3.3-.5 2v2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.2 23.5q-.3-.2-.4-.5v-2.6l.1-.2h-4.3l.1.2V23l-.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.3 23.5q.4-.2.4-.5v-2.5l-.3-.3h3l-.4.3V23q0 .3.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.7 23.5q.3-.2.4-.6v-2.1l-.2-.4h1.9l-.3.4v2.1q.1.4.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.3 20.4h-1v3h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.5 21.3h-.4v1.6h.4zm-3 0H33v1.6h.3zm3.3-2.8h-.4v1.7h.4zm0-.3h-.4v.3h.4zm-3.5.7h-.7v1.3h.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeWidth: 0.1,
    d: "M36.8 18.5h-.4v1.7h.4zm0 0h-.4v-.3h.4zm-.3 2.8h-.4v1.6h.4zm-3 0H33v1.6h.3zm-.2-2.4h-.7v1.3h.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36.4 20.2v-3c-.1 0-.2.5-.4.5q-.3 0 0-.3v-.7q-.3.5-.3.2.2-.2.1-.7-.2.4-.2.1.2-.2 0-.6-.1.5-.2 0 .1-.4-.4-.7l-.2-.3-.2.3q-.5.2-.4.8 0 .3-.2-.1-.2.4 0 .6 0 .3-.2-.1-.1.4.1.7 0 .2-.2-.2-.2.5 0 .7v.3l-.5-.4v2.9zM37 18v2.2h-.3V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37 19.4q-.5.3-.6.8h.7zm-4.3-.7v1.5h-.2v-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M32.5 19.4q.6.2.7.8h-.7zm2-3.4v-.3l.3-.2.3.3.1-.1v.2l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.5 16.5v-.4l.3-.2.3.3.1-.1v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m34.5 17.2-.3-.3v-.4q.2 0 .2.2l.4-.4.4.4.2-.2v.4l-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m34.4 17.8-.3-.4v-.3l.3.2q0-.4.4-.5t.4.5q.1-.2.4-.2v.3l-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.3 19s-.5-.4-.5-.6v-.6q.3 0 .5.4 0-.7.5-1 .5.3.6 1 0-.3.4-.4v.6c0 .2-.4.6-.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m34.3 19.7-.5-.5v-.5q.3 0 .5.3l.5-.9q.5.3.6 1 0-.4.4-.4v.5l-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.1 20.2q0-.7.7-1.2.7.4.8 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.9 20.4v-.7l.5.4q0-.5.4-.7.4.3.5.7l.5-.4v.7zM15 26h24.6v1.2H15.1zm-.6 1.2h25.9v1.2H14.4zm2-3.1h21.9v.8h-22zm-.7.8H39v1H15.7zm1-1.5H38v.7H16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19 23.4h1.6v5H19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.4 23.4h.9v5h-1zm7.1 0h1.6v5h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.9 23.4h.9v5h-1zm7.1 0h1.6v5H34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.4 23.4h.9v5h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.7 23H37m-17.6 4.8h.9m-1-.6h1m-1-.6h1m-1-.7h1m-1-.6h1m-1-.6h1m-1-.6h1m6.6 3.7h.8m-.8-.6h.8m-.8-.6h.8m-.8-.7h.8m-.8-.6h.8m-.8-.6h.8M27 24h.8m6.7 3.7h.9m-1-.6h1m-1-.6h1m-1-.7h1m-1-.6h1m-1-.6h1m-1-.6h1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKh);
export default __webpack_public_path__ + "static/media/kh.a39da91ee94c4fe36e317c3e33c01066.svg";
export { ForwardRef as ReactComponent };